<div style="display: flex; flex-direction: row; justify-content: center">
  <div style="width: 100%; text-align: center; padding-left: 20%">
    <h1 mat-dialog-title="mat-dialog-title">{{ FormTitle }}</h1>
  </div>
  <div class="head-button">
    <button class="bg-close-button" mat-mini-fab color="none">
      <mat-icon
        mat-dialog-close="mat-dialog-close"
        style="width: 4vh; height: 4vh"
        >close</mat-icon
      >
    </button>
  </div>
</div>
<br />

<div class="main-container">
  <mat-dialog-content>
      <form
        [formGroup]="companiaForm"
        (ngSubmit)="companiaForm.valid ? onSubmit(companiaForm.value) : ''"
      >
        <h2>Información Básica:</h2>

        <div class="first-row">
          <div class="row-item">
            <mat-form-field class="input">
              <mat-label>Nombre de la empresa</mat-label>
              <mat-error>Este campo es requerido.</mat-error>
              <input
                matInput="matInput"
                formControlName="name"
                placeholder="Ej: Eter Software"
                required="required"
                autocomplete="off"
              />
            </mat-form-field>
          </div>

          <div class="row-item">
            <mat-form-field class="input">
              <mat-label>NIT</mat-label>
              <mat-error>Este campo es requerido.</mat-error>
              <input
                matInput="matInput"
                formControlName="nit"
                placeholder="Ej: 8.000.000.000-1"
                required="required"
                autocomplete="off"
              />
            </mat-form-field>
          </div>
        </div>

        <div class="default-row">
          <div class="row-item">
            <mat-form-field>
              <mat-label>Estado:</mat-label>
              <mat-select formControlName="state" [(ngModel)]="selOpEstado">
                <mat-option value="0">Inactiva</mat-option>
                <mat-option value="1">Activa</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="row-item">
            <file-input
            style="width: 100%;"
              [params]="fileInput"
              (fileSave)="fileSave($event)"
            ></file-input>
          </div>
        </div>

        <div class="default-row">
          <div class="row-item">
            <mat-form-field class="input">
              <mat-label>Descripción</mat-label>
              <mat-error>Este campo es requerido.</mat-error>
              <input
                matInput="matInput"
                formControlName="description"
                placeholder="Ej: Mineria, transporte"
                required="required"
                autocomplete="off"
              />
            </mat-form-field>
          </div>
        </div>

        <h2>Ubicación:</h2>

        <div class="default-row">
          <div class="row-item">
            <mat-form-field class="input">
              <mat-label>Dirección</mat-label>
              <mat-error>Este campo es requerido.</mat-error>
              <input
                matInput="matInput"
                formControlName="address"
                placeholder="Ej: Calle 74 # 54-39 Of. 201"
                required="required"
                autocomplete="off"
              />
            </mat-form-field>
          </div>

          <div class="row-item" style='width:100%;'>
            <combos
            [configuration]='combosConfigCountry'
            [reloadCombo]='reloadComboCountry'
            [required]="true"
            (changeOption)='changesCountry($event)'
            >
           </combos>
          </div>
        </div>

        <div class="default-row">
          <div class="row-item" style='width:100%;'>
            <combos
            [configuration]='combosConfigRegion'
            [reloadCombo]='reloadComboRegion'
            [required]="true"
            [filter]="true"
            (changeOption)='changesRegion($event)'
            >
           </combos>
          </div>

          <div class="row-item" style='width:100%;'>
            <combos
            [configuration]='combosConfigCity'
            [reloadCombo]='reloadComboCity'
            [required]="true"
            [filter]="true"
            [control]="companiaForm.get('cityId')"
            >
           </combos>
          </div>
        </div>

        <h2>Contacto:</h2>

        <div class="default-row">
          <div class="row-item">
            <mat-form-field class="input">
              <mat-label>Nombre encargado</mat-label>
              <mat-error>Este campo es requerido.</mat-error>
              <input
                matInput="matInput"
                formControlName="manager"
                placeholder="Ej: Daniel Rincón"
                required="required"
                autocomplete="off"
              />
            </mat-form-field>
          </div>

          <div class="row-item">
            <mat-form-field class="input">
              <mat-label>Teléfono</mat-label>
              <mat-error>Este campo es requerido.</mat-error>
              <input
                matInput="matInput"
                formControlName="phone"
                placeholder="Ej: (057)8891650"
                required="required"
                autocomplete="off"
              />
            </mat-form-field>
          </div>
        </div>

        <div class="default-row">
          <div class="row-item">
            <mat-form-field class="input">
              <mat-label>Celular</mat-label>
              <mat-error>Este campo es requerido.</mat-error>
              <input
                matInput="matInput"
                formControlName="mobile"
                placeholder="Ej: 350 576 4704"
                required="required"
                autocomplete="off"
              />
            </mat-form-field>
          </div>

          <div class="row-item">
            <mat-form-field class="input">
              <mat-label>E-mail</mat-label>
              <mat-error>Este campo es requerido.</mat-error>
              <input
                matInput="matInput"
                formControlName="email"
                placeholder="sucorreo@dominio.com"
                required="required"
                autocomplete="off"
              />
            </mat-form-field>
          </div>
        </div>

        <h2>Plan:</h2>


        <div class="default-row">
          <div class="row-item">
            <mat-form-field class="input">
              <mat-label>Plan:</mat-label>
              <mat-error>Este campo es requerido.</mat-error>
              <mat-select
                formControlName="planId"
                required="required"
              >
                <mat-option
                  *ngFor="let plan of comboPlans"
                  value="{{ plan.id }}"
                >
                  {{ plan.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="row-item">
            <mat-form-field>
              <mat-label>Fecha ulitmo pago</mat-label>
              <input matInput [matDatepicker]="pickerNacimiento" autocomplete="off" matInput
                  formControlName='lastPaymentDate' required>
              <mat-datepicker-toggle matSuffix [for]="pickerNacimiento">
              </mat-datepicker-toggle>
              <mat-datepicker #pickerNacimiento [touchUi]='movil?true:false'></mat-datepicker>
              <mat-error>Campo requerido</mat-error>
          </mat-form-field>
          </div>
        </div>

        <div class="default-row">
          <div class="row-item">
            <mat-form-field class="input">
              <mat-label>Periodo de pago</mat-label>
              <mat-error>Este campo es requerido.</mat-error>
              <input
                matInput="matInput"
                formControlName="paymentPeriod"
                required="required"
                autocomplete="off"
                type="number"
              />
            </mat-form-field>
          </div>

          <div class="row-item">
            <mat-form-field class="input">
              <mat-label>Numero de items </mat-label>
              <mat-error>Este campo es requerido.</mat-error>
              <input
                matInput="matInput"
                formControlName="itemCount"
                required="required"
                autocomplete="off"
                type="number"
              />
            </mat-form-field>
          </div>
        </div>

        <h2>Selección de Modulos:</h2>
        <div class="row-item" style='width:100%;'>
          <combos
          [configuration]='combosConfigModule'
          [reloadCombo]='reloadComboModule'
          [required]="true"
          [filter]="true"
          [checkbox]="true"
          (changeOption)='ValueIDModule($event)'
          >
         </combos>
        </div>



        <div
          style="
            display: flex;
            align-items: flex-end;
            width: 100%;
            height: 7vh;
            justify-content: space-around;
          "
        >
          <button
            mat-raised-button
            color="primary"
            mat-dialog-close="mat-dialog-close"
          >
            Cancelar
          </button>
          <button
            type="submit"
            mat-raised-button
            color="warn"
            [mat-dialog-close]="true"
            [disabled]="!companiaForm.valid"
          >
            {{ onSubmitBotonText }}
          </button>
        </div>
      </form>
  </mat-dialog-content>
</div>
